import { createSelector } from 'reselect';
import { RootState } from '../../reducer';

const menuSelector = (state: RootState) => state.menu;

export const menuListSelector = createSelector(
  menuSelector,
  (menu) => menu.menuList
);

export const makeSearchCategoriesSelector = (category: string) =>
  createSelector(
    menuSelector,
    (menu) =>
      menu.menuList.find((m) => m.title === category)?.search_categories ??
      undefined
  );

export const makeSelectCategory = (productCategory: string) =>
  createSelector(
    menuListSelector,
    (menus) =>
      menus.find((m) =>
        m.search_categories.some((cat) => cat.name === productCategory)
      )?.title
  );

export const makeSelectCategoryByPathCategory = (
  categoryPath: string,
  subCategoryPath?: string
) =>
  createSelector(menuListSelector, (menus) => {
    if (subCategoryPath) {
      return menus.find((menu) =>
        menu.sub_categories.some(
          (sub) =>
            sub.path === `/list/subcategory/${categoryPath}/${subCategoryPath}`
        )
      )?.title;
    }
    return menus.find((m) => m.product_list_path === `/list/${categoryPath}`)
      ?.title;
  });

export const makeSelectCategoryPathByPathCategory = (
  categoryPath: string,
  subCategoryPath?: string
) =>
  createSelector(menuListSelector, (menus) => {
    if (subCategoryPath) {
      return menus.find((menu) =>
        menu.sub_categories.some(
          (sub) =>
            sub.path === `/list/subcategory/${categoryPath}/${subCategoryPath}`
        )
      )?.product_list_path;
    }
    return menus.find((m) => m.product_list_path === `/list/${categoryPath}`)
      ?.product_list_path;
  });

export const makeSelectSubCategoryByPathCategory = (
  categoryPath: string,
  subCategoryPath: string
) =>
  createSelector(menuListSelector, (menus) => {
    let subCategory: string | undefined;
    menus.some((menu) =>
      menu.sub_categories.some((sub) => {
        if (
          sub.path === `/list/subcategory/${categoryPath}/${subCategoryPath}`
        ) {
          subCategory = sub.name;
          return true;
        }
        return false;
      })
    );
    return subCategory;
  });

export const makeSelectCategoryByBrandPathCategory = (categoryPath: string) =>
  createSelector(menuListSelector, (menus) => {
    return menus.find(
      (m) => m.brand_list_path === `/BrandListView/${categoryPath}`
    )?.title;
  });

export const makeSelectListPath = (category?: string, subCategory?: string) =>
  createSelector(menuListSelector, (menus) => {
    const menu = menus.find((m) => m.title === category);
    if (!subCategory) {
      return menu?.product_list_path;
    }
    return menu?.sub_categories.find((sub) => sub.name === subCategory)?.path;
  });

export const makeSelectBrandListPath = (category?: string) =>
  createSelector(
    menuSelector,
    (menu) =>
      menu.menuList.find((m) => m.title === category)?.brand_list_path ??
      undefined
  );
